export const EN_TRANSLATIONS = {
  "language": {
    "genCode": "en",
    "localeCode": "en_US",
    "name": "English"
  },
  "header": {
    "login": "Log in",
    "register": "Register now",
    "help": "Help",
    "assessment": "Assessment",
    "continueIbis": "Continue to IBIS",
    "students": "Students",
    "requestResults": "Request results replacements",
    "copyright": "© International Baccalaureate Organization, 2026",
    "languagePolicy": "Language Policy",
    "terms": "Terms and Conditions",
    "privacy": "IB Privacy Policy",
    "myIB": "My IB",
    "store": "Store",
    "blogs": "Blogs",
    "askQuestion": "Ask a Question",
    "ibis": "IBIS"
  },

  "auth": {
    "welcome": "Welcome.",
    "movedSystem": "We have moved to a more streamlined and secure login system. To get started, choose an option below.",
    "firstTime": "It’s your first time using the new login system",
    "setupPassword": "Set up new password",
    "alreadySetup": "You’ve already set up a new password",
    "fantastic": "Fantastic! You can now log in with your new password."
  },

  "register": {
    "title": "Create my account",
    "alreadyAccount": "Already have an account?",
    "loginHere": "Login here",
    "troubleAccess": "Having trouble accessing your account?",
    "contactUs": "Contact us",
    "firstName": "First Name",
    "lastName": "Last Name",
    "salutation": "Salutation",
    "dob": "Date of birth",
    "countryOfBirth": "Country or territory of birth",
    "placeOfBirth": "Place of birth",
    "preferredLanguage": "Your preferred language",
    "selectOption": "Select an option",
    "emailWarning": "Warning: Your email will be your unique username.",
    "emailLongTerm": "Please choose an email that you’ll have access to long term. To change this information later, you’ll need to request a manual change.",
    "email": "Email",
    "confirmEmail": "Confirm Email",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "schoolEmail": "School email",
    "connectedAccount": "That is connected to your account",
    "agreeTerms": "I agree to IB’s Terms and Conditions",
    "submit": "Create my account",
    "privacyNote": "Any personal data you provide will be handled according to IB’s Privacy Policy",
    "warningTitle": "Warning:",
    "warningText": "Your email will be your unique username.",
    "warningNote": "Please choose an email that you’ll have access to long term. To change this information",
    "warningLastPrefix": "later, you’ll need to",
    "warningLastLink": "request a manual change.",
    "select": "None",
    "agree": "I agree to",
    "terms": "IB’s Terms and Conditions",
    "privacyPrefix": "Any personal data you provide will be handled according to",
    "privacyLink": "IB’s Privacy Policy"
  },

  "success": {
    "title": "Almost there!",
    "accountReady": "You can now access MY IB and the rest of IB's online tools.",
    "confirmEmail": "We've sent an email with instructions to log in to My IB. Please check your inbox and follow the steps provided.",
    "arrivalTime": "It usually arrives within a few minutes.",
    "startBrowsing": "Back to Login"
  },

  "confirmation": {
    "emailSent": "We've sent an email with instructions to log in to My IB. Please check your inbox and follow the steps provided."
  },

  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "backToLogin": "Back to Login"
  },

  "login": {
    "email": "Email",
    "password": "Password",
    "login": "Log in",
    "noAccount": "Don’t have an account?",
    "registerNow": "Register now."
  },

  "passwordReset": {
    "title": "Set up your new password",
    "instruction": "To start using the new system, you are required to reset your password the first time you log in. Thank you.",
    "emailAddress": "Email Address",
    "next": "Next",
    "verifyOtp": "Verify OTP",
    "otpInstruction": "Enter the 6-digit code sent to your email",
    "otpSentTo": "OTP sent to",
    "enterOtp": "Enter OTP",
    "resendOtp": "Resend OTP",
    "resetPassword": "Reset Password",
    "resettingFor": "Resetting password for",
    "newPassword": "New Password",
    "enterNewPassword": "Enter new password",
    "confirmNewPassword": "Confirm new password",
    "securityVerification": "Security Verification",
    "verificationSuccess": "Verification successful"
  },
  "errors": {
    "required": "{field} is required.",
    "passwordPattern": "Password must contain at least one uppercase letter, one number, and one special character.",
    "invalidEmail": "Enter a valid email address.",
    "invalidDate": "Enter a valid date of birth. You must be at least 18 years old.",
    "invalidLeapYearDate": "Enter a valid date of birth. February 29 is only valid in a leap year.",
    "invalidDateFormat": "The date of birth format is invalid. Please use DD/MM/YYYY format.",
    "emailMismatch": "Email and Confirm Email must match.",
    "passwordMismatch": "Password and Confirm Password must match.",
    "minLength": "Minimum {{length}} characters required.",
    "maxLength": "Must not exceed {{max}} characters.",
    "linkNotWorking": "This link doesn't seem to work anymore. Please request a new one.",
    "requiredFieldsInvalid": "Please check that all required fields are filled in correctly.",
    "acceptTerms": "Please accept the Terms and Conditions to continue.",
    "genericServerError": "Something went wrong on our side. Please try again in few minutes.",
    "linkAlreadyUsed": "This link has already been used. Try logging in instead.",
    "emailAlreadyUsed": "A record with these details already exists.",
    "nameTooLong": "Your name is too long. Please keep it under 40 characters.",
    "invalidInformation": "Some information doesn't look right. Please double-check and try again.",
    "sessionVerificationFailed": "We couldn't verify your session. Please refresh the page and try again.",
    "tooManyAttempts": "Too many attempts. Please wait a moment before trying again.",
    "registrationUnavailable": "Registration is temporarily unavailable. Please try again in few minutes.",
    "offline": "It looks like you're offline. Please check your connection and try again.",
    "weakPassword": "The password you entered is not allowed. Please choose a different password."
  }
} as const;
